// ماژول‌های در حال توسعه --------------------------------------------------
// این فایل تنها مرجع ماژول‌هایی است که در منوی سایدبار نمایش داده می‌شوند
// اما هنوز صفحه‌ای برای آن‌ها پیاده‌سازی نشده است.
// از این لیست هم مسیرهای روتر (router/modules/pdev.js) ساخته می‌شود و هم
// آیتم‌های منوی ماژول‌ها در TheHeader و هم لینک‌های داشبورد «در حال توسعه».

// مراحل چرخه توسعه هر ماژول (به ترتیب)
export const developmentSteps = [
  "تحلیل و امکان‌سنجی",
  "طراحی تجربه کاربری",
  "پیاده‌سازی",
  "تست و کنترل کیفیت",
  "انتشار",
];

const modules = [
  // ------------------------------------------------ مدیریت مالی
  {
    key: "pettyCash",
    path: "petty-cash",
    title: "مدیریت تنخواه",
    group: "مدیریت مالی",
    icon: "mdi-wallet-outline",
    description:
      "تعریف تنخواه‌گردان‌ها، ثبت درخواست و تسویه تنخواه به همراه اتصال خودکار به اسناد حسابداری و خزانه.",
    features: [
      "تعریف تنخواه‌گردان و سقف اعتبار",
      "ثبت و گردش درخواست تنخواه",
      "تسویه و صدور سند خودکار",
      "گزارش مانده و گردش تنخواه",
    ],
    progress: 35,
    step: 1,
    release: "نیمه دوم ۱۴۰۵",
  },
  {
    key: "fixedAssets",
    path: "fixed-assets",
    title: "اموال و دارایی‌های ثابت",
    group: "مدیریت مالی",
    icon: "mdi-office-building-outline",
    description:
      "شناسنامه اموال، پلاک‌گذاری، محاسبه استهلاک و مدیریت نقل‌وانتقال دارایی‌های ثابت سازمان.",
    features: [
      "شناسنامه و پلاک‌گذاری اموال",
      "محاسبه خودکار استهلاک",
      "نقل و انتقال و تحویل اموال",
      "گزارش‌های اموال و استهلاک انباشته",
    ],
    progress: 20,
    step: 1,
    release: "نیمه دوم ۱۴۰۵",
  },
  {
    key: "facilities",
    path: "facilities",
    title: "تسهیلات و اعتبارات",
    group: "مدیریت مالی",
    icon: "mdi-bank-outline",
    description:
      "مدیریت وام‌ها و تسهیلات بانکی، جدول اقساط، محاسبه سود و ثبت اسناد مرتبط.",
    features: [
      "ثبت قرارداد تسهیلات",
      "تولید جدول اقساط",
      "محاسبه سود و جرایم تأخیر",
      "گزارش بدهی و سررسید اقساط",
    ],
    progress: 15,
    step: 0,
    release: "سال ۱۴۰۶",
  },
  {
    key: "pbdgt",
    path: "budget",
    title: "بودجه",
    group: "مدیریت مالی",
    icon: "mdi-calculator-variant-outline",
    description:
      "بودجه‌ریزی عملیاتی، تخصیص اعتبار به مراکز هزینه و کنترل مصرف بودجه در برابر عملکرد واقعی.",
    features: [
      "تعریف سرفصل و ردیف بودجه",
      "تخصیص اعتبار به مراکز هزینه",
      "کنترل مصرف و مانده اعتبار",
      "گزارش مقایسه بودجه و عملکرد",
    ],
    progress: 30,
    step: 1,
    release: "نیمه دوم ۱۴۰۵",
  },

  // ------------------------------------------------ مدیریت ارتباط با مشتری
  {
    key: "afterSales",
    path: "after-sales",
    title: "خدمات پس‌از فروش",
    group: "مدیریت ارتباط با مشتری",
    icon: "mdi-tools",
    description:
      "ثبت درخواست خدمات، مدیریت گارانتی، تعریف تیم‌های خدماتی و پیگیری رضایت مشتری.",
    features: [
      "ثبت و گردش درخواست خدمات",
      "مدیریت گارانتی و قراردادهای پشتیبانی",
      "زمان‌بندی و اعزام تکنسین",
      "نظرسنجی و پایش رضایت مشتری",
    ],
    progress: 25,
    step: 1,
    release: "نیمه دوم ۱۴۰۵",
  },

  {
    key: "ecommerce",
    path: "ecommerce",
    title: "تجارت الکترونیک",
    group: "مدیریت ارتباط با مشتری",
    icon: "mdi-cart-outline",
    description:
      "فروشگاه اینترنتی یکپارچه با انبار و فروش، شامل سبد خرید، درگاه پرداخت و پیگیری سفارش آنلاین.",
    features: [
      "کاتالوگ آنلاین کالا",
      "سبد خرید و درگاه پرداخت",
      "همگام‌سازی موجودی با انبار",
      "پیگیری آنلاین سفارش",
    ],
    progress: 10,
    step: 0,
    release: "سال ۱۴۰۶",
  },

  // ------------------------------------------------ مدیریت زنجیره تامین
  {
    key: "distribution",
    path: "distribution",
    title: "توزیع",
    group: "مدیریت زنجیره تامین",
    icon: "mdi-package-variant-closed",
    description:
      "مدیریت شبکه توزیع و ویزیتوری، تعریف مسیر فروش و تسویه محموله‌های توزیع‌کنندگان.",
    features: [
      "تعریف مسیر و منطقه توزیع",
      "مدیریت ویزیتور و سفارش‌گیری",
      "تخصیص محموله به توزیع‌کننده",
      "تسویه و گزارش فروش مسیر",
    ],
    progress: 10,
    step: 0,
    release: "سال ۱۴۰۶",
  },
  {
    key: "logistics",
    path: "logistics",
    title: "لجستیک",
    group: "مدیریت زنجیره تامین",
    icon: "mdi-truck-outline",
    description:
      "مدیریت حمل و توزیع، برنامه‌ریزی مسیر، مدیریت ناوگان و پیگیری محموله‌ها تا تحویل نهایی.",
    features: [
      "برنامه‌ریزی حمل و مسیریابی",
      "مدیریت ناوگان و رانندگان",
      "صدور بارنامه و حواله خروج",
      "رهگیری آنلاین محموله",
    ],
    progress: 20,
    step: 1,
    release: "سال ۱۴۰۶",
  },

  // ------------------------------------------------ مدیریت سرمایه انسانی
  {
    key: "recruitment",
    path: "recruitment",
    title: "جذب و استخدام",
    group: "مدیریت سرمایه انسانی",
    icon: "mdi-account-search-outline",
    description:
      "مدیریت آگهی‌های شغلی، بانک رزومه، فرآیند مصاحبه و صدور حکم استخدام.",
    features: [
      "تعریف نیازمندی و آگهی شغلی",
      "بانک رزومه و غربالگری",
      "مدیریت جلسات مصاحبه و ارزیابی",
      "صدور حکم و انتقال به پرونده پرسنلی",
    ],
    progress: 30,
    step: 1,
    release: "نیمه دوم ۱۴۰۵",
  },
  {
    key: "training",
    path: "training",
    title: "آموزش",
    group: "مدیریت سرمایه انسانی",
    icon: "mdi-school-outline",
    description:
      "نیازسنجی آموزشی، تقویم دوره‌ها، ثبت‌نام کارکنان و صدور گواهینامه و ارزیابی اثربخشی.",
    features: [
      "نیازسنجی و تقویم آموزشی",
      "ثبت‌نام و حضور و غیاب دوره",
      "ارزیابی اثربخشی آموزش",
      "شناسنامه آموزشی کارکنان",
    ],
    progress: 15,
    step: 0,
    release: "سال ۱۴۰۶",
  },
  {
    key: "payslipPortal",
    path: "payslip-portal",
    title: "سامانه فیش حقوقی",
    group: "مدیریت سرمایه انسانی",
    icon: "mdi-file-document-outline",
    description:
      "درگاه اختصاصی کارکنان جهت مشاهده و دریافت فیش حقوقی، سوابق بیمه و مانده مرخصی.",
    features: [
      "ورود اختصاصی کارکنان",
      "مشاهده و دریافت فیش حقوقی",
      "مشاهده سوابق بیمه و مالیات",
      "مانده مرخصی و مساعده",
    ],
    progress: 40,
    step: 2,
    release: "نیمه اول ۱۴۰۵",
  },
  {
    key: "performanceMonitoring",
    path: "performance-monitoring",
    title: "پایش عملکرد",
    group: "مدیریت سرمایه انسانی",
    icon: "mdi-chart-timeline-variant",
    description:
      "تعریف شاخص‌های کلیدی عملکرد، ارزیابی دوره‌ای کارکنان و تحلیل نتایج در سطح سازمان.",
    features: [
      "تعریف شاخص‌های عملکرد (KPI)",
      "ارزیابی دوره‌ای و ۳۶۰ درجه",
      "برنامه بهبود فردی",
      "داشبورد تحلیلی عملکرد",
    ],
    progress: 10,
    step: 0,
    release: "سال ۱۴۰۶",
  },

  // ------------------------------------------------ مدیریت عملیات
  {
    key: "projectManagement",
    path: "project-management",
    title: "مدیریت پروژه",
    group: "مدیریت عملیات",
    icon: "mdi-sitemap-outline",
    description:
      "تعریف ساختار شکست کار، زمان‌بندی، تخصیص منابع و کنترل پیشرفت و هزینه پروژه‌ها.",
    features: [
      "ساختار شکست کار (WBS)",
      "زمان‌بندی و نمودار گانت",
      "تخصیص منابع و هزینه",
      "کنترل پیشرفت و انحراف پروژه",
    ],
    progress: 25,
    step: 1,
    release: "نیمه دوم ۱۴۰۵",
  },
  {
    key: "qualityManagement",
    path: "quality-management",
    title: "مدیریت کیفیت",
    group: "مدیریت عملیات",
    icon: "mdi-check-decagram-outline",
    description:
      "تعریف طرح‌های بازرسی، ثبت نتایج کنترل کیفی، مدیریت عدم انطباق و اقدامات اصلاحی.",
    features: [
      "تعریف طرح و پارامترهای بازرسی",
      "ثبت نتایج کنترل کیفی",
      "مدیریت عدم انطباق (NCR)",
      "اقدامات اصلاحی و پیشگیرانه",
    ],
    progress: 30,
    step: 1,
    release: "نیمه دوم ۱۴۰۵",
  },

  // ------------------------------------------------ مدیریت تکنولوژی
  {
    key: "maintenance",
    path: "maintenance",
    title: "مدیریت تعمیرات و نگهداری",
    group: "مدیریت تکنولوژی",
    icon: "mdi-wrench-outline",
    description:
      "شناسنامه تجهیزات، برنامه نگهداری پیشگیرانه، ثبت خرابی و مدیریت دستور کارهای تعمیراتی.",
    features: [
      "شناسنامه و درخت تجهیزات",
      "برنامه نگهداری پیشگیرانه (PM)",
      "ثبت خرابی و دستور کار",
      "تحلیل توقفات و هزینه تعمیرات",
    ],
    progress: 20,
    step: 1,
    release: "سال ۱۴۰۶",
  },
  {
    key: "engineeringDesign",
    path: "engineering-design",
    title: "طراحی و مهندسی",
    group: "مدیریت تکنولوژی",
    icon: "mdi-drawing-box",
    description:
      "مدیریت درخت محصول، نقشه‌ها و مدارک فنی، کنترل نسخه و گردش تأیید تغییرات مهندسی.",
    features: [
      "مدیریت درخت محصول (BOM)",
      "بایگانی نقشه و مدارک فنی",
      "کنترل نسخه و تاریخچه تغییرات",
      "گردش تأیید تغییر مهندسی",
    ],
    progress: 15,
    step: 0,
    release: "سال ۱۴۰۶",
  },
  {
    key: "rnd",
    path: "rnd",
    title: "تحقیق و توسعه (R&D)",
    group: "مدیریت تکنولوژی",
    icon: "mdi-flask-outline",
    description:
      "مدیریت پروژه‌های تحقیقاتی، ثبت ایده، نمونه‌سازی و پیگیری تجاری‌سازی محصولات جدید.",
    features: [
      "بانک ایده و ارزیابی اولیه",
      "مدیریت پروژه‌های تحقیقاتی",
      "ثبت نتایج آزمون و نمونه‌سازی",
      "پیگیری تجاری‌سازی محصول",
    ],
    progress: 10,
    step: 0,
    release: "سال ۱۴۰۶",
  },
  {
    key: "knowledgeManagement",
    path: "knowledge-management",
    title: "مدیریت دانش",
    group: "مدیریت تکنولوژی",
    icon: "mdi-lightbulb-on-outline",
    description:
      "ثبت و طبقه‌بندی تجربیات و مستندات سازمانی به همراه موتور جست‌وجو و مسیرهای یادگیری.",
    features: [
      "بانک مستندات و تجربیات",
      "طبقه‌بندی و برچسب‌گذاری دانش",
      "جست‌وجوی پیشرفته",
      "مسیر یادگیری و اشتراک دانش",
    ],
    progress: 10,
    step: 0,
    release: "سال ۱۴۰۶",
  },

  // ------------------------------------------------ مدیریت استراتژیک
  {
    key: "bpms",
    path: "bpms",
    title: "BPMS",
    group: "مدیریت استراتژیک",
    icon: "mdi-transit-connection-variant",
    description:
      "طراحی و اجرای فرآیندهای سازمانی به‌صورت گرافیکی، تعریف فرم‌ها، قوانین و کارتابل یکپارچه.",
    features: [
      "طراح گرافیکی فرآیند (BPMN)",
      "فرم‌ساز و قوانین گردش کار",
      "کارتابل یکپارچه کاربران",
      "پایش و تحلیل فرآیندها",
    ],
    progress: 35,
    step: 2,
    release: "نیمه دوم ۱۴۰۵",
  },
  {
    key: "bi",
    path: "bi",
    title: "BI",
    group: "مدیریت استراتژیک",
    icon: "mdi-chart-box-outline",
    description:
      "داشبوردهای تحلیلی مدیریتی، گزارش‌ساز پویا و تحلیل داده‌های تجمیعی تمام ماژول‌های سیستم.",
    features: [
      "داشبوردساز مدیریتی",
      "گزارش‌ساز پویا",
      "تحلیل روند و مقایسه دوره‌ای",
      "خروجی و اشتراک‌گذاری گزارش",
    ],
    progress: 25,
    step: 1,
    release: "نیمه دوم ۱۴۰۵",
  },
  {
    key: "officeAutomation",
    path: "office-automation",
    title: "اتوماسیون اداری",
    group: "مدیریت استراتژیک",
    icon: "mdi-email-newsletter",
    description:
      "دبیرخانه و مکاتبات اداری، گردش نامه، امضای دیجیتال و بایگانی الکترونیکی مکاتبات.",
    features: [
      "دبیرخانه و شماره‌گذاری نامه",
      "گردش و ارجاع مکاتبات",
      "امضای دیجیتال",
      "بایگانی الکترونیکی",
    ],
    progress: 15,
    step: 0,
    release: "سال ۱۴۰۶",
  },
  {
    key: "riskInnovation",
    path: "risk-innovation",
    title: "مدیریت ریسک و نوآوری",
    group: "مدیریت استراتژیک",
    icon: "mdi-shield-search",
    description:
      "شناسایی و ارزیابی ریسک‌های سازمانی، تعریف اقدامات کنترلی و مدیریت پرتفوی ابتکارات نوآورانه.",
    features: [
      "شناسایی و ثبت ریسک",
      "ماتریس ارزیابی ریسک",
      "اقدامات کنترلی و پایش",
      "مدیریت ابتکارات نوآورانه",
    ],
    progress: 10,
    step: 0,
    release: "سال ۱۴۰۶",
  },
  {
    key: "publicRelations",
    path: "public-relations",
    title: "مدیریت روابط عمومی",
    group: "مدیریت استراتژیک",
    icon: "mdi-bullhorn-outline",
    description:
      "مدیریت اطلاعیه‌ها و رویدادهای سازمانی، ارتباط با رسانه‌ها و پایش بازخوردهای بیرونی.",
    features: [
      "انتشار اطلاعیه و اخبار سازمانی",
      "تقویم رویدادها",
      "مدیریت ارتباط با رسانه",
      "پایش بازخورد و افکارسنجی",
    ],
    progress: 10,
    step: 0,
    release: "سال ۱۴۰۶",
  },
];

// نام مسیر روتر متناظر با هر ماژول در حال توسعه
export function devRouteName(item) {
  if (!item) return null;
  return "DEV_" + item.key;
}

// نام مسیر روتر بر اساس کلید ماژول (برای استفاده در منوی ماژول‌ها)
export function devRouteNameByKey(key) {
  return devRouteName(findUnderDevelopmentModule(key));
}

export function findUnderDevelopmentModule(key) {
  if (!key) return null;
  return modules.find((i) => i.key === key) || null;
}

export function findUnderDevelopmentModuleByRoute(routeName) {
  if (!routeName) return null;
  return modules.find((i) => devRouteName(i) === routeName) || null;
}

// گروه‌بندی ماژول‌ها بر اساس حوزه مدیریتی (برای نمایش در داشبورد)
export function underDevelopmentGroups() {
  const groups = [];
  modules.forEach((item) => {
    let group = groups.find((g) => g.title === item.group);
    if (!group) {
      group = { title: item.group, modules: [] };
      groups.push(group);
    }
    group.modules.push(item);
  });
  return groups;
}

export const underDevelopmentModules = modules;

export default modules;
